import React, { useState, useEffect } from "react";
import {
  Layout,
  Menu,
  Dropdown,
  Avatar,
  message,
  Modal,
  Button,
  Row,
  Col,
  Input,
  Form,
  Breadcrumb,
} from "antd";
import { Link, withRouter } from "react-router-dom";
//引入路由
import { adminRoutes } from "@/router";
import {
  LogoutOutlined,
  DownOutlined,
  GlobalOutlined,
  BellOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { loginOutApi1 } from "@/services/auth";
import { clearAccountInfo } from "@utils/auth";
import "@/components/less/frame.less";
import "@/components/less/newframe.less";
import logo from "@/assets/logo.png";
//语言切换
import intl from "react-intl-universal";
import en_US from "@/locales/en_US/index.json";
import zh_CN from "@/locales/zh_CN/index.json";
import { createFromIconfontCN } from "@ant-design/icons";
import codeImg from "@/image/code.png";
import { deleteAccount, sendVerifyCode1 } from "../services/auth";
import { isDetailType, setDetailType, getDetailType } from "@utils/auth";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import QuickActions from "./QuickActions";
import { isBrowserMaximized } from "@/utils/utils";

const IconFont = createFromIconfontCN({
  scriptUrl: [process.env.REACT_APP_ICON],
});

const locales = {
  en_US,
  zh_CN,
};

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const VersionCompare = () => {
  function toOldVersion() {
    sessionStorage.setItem("dots-oldversion", "1");
    window.location.href = window.location.origin;
  }
  return (
    <div className="version-compare-container">
      <Row className="version-row" align="middle">
        <Col className="version-item other-item">
          <span
            className="version-text"
            onClick={toOldVersion}
            style={{ cursor: "pointer" }}
          >
            {intl.get("oldVersion")}
          </span>
        </Col>
        <Col className="version-separator other-item">
          <span className="version-text version-line">—</span>
        </Col>
        <Col className="version-item current-item">
          <span className="version-text">{intl.get("newVersion")}</span>
        </Col>
      </Row>
    </div>
  );
};

const LanguageCompare = () => {
  function toOther(val) {
    if (val !== localStorage.getItem("language_type")) {
      localStorage.setItem("language_type", val);
      const date = new Date("Fri, 31 Dec 9999 23:59:59 GMT");
      document.cookie =
        "languageType=" +
        val +
        "; expires=" +
        date.toUTCString() +
        ";path=/;domain=.dataoceanai.com";
      window.location.reload(); //点击后刷新，这样state里的代码会再次执行，从而达到切换效果
    }
  }
  return (
    <div className="version-compare-container">
      <Row className="version-row" align="middle">
        <Col
          className={[
            "version-item",
            localStorage.getItem("language_type") === "en_US"
              ? "current-item"
              : "other-item",
          ]}
        >
          <span
            className="version-text"
            onClick={() => {
              toOther("en_US");
            }}
            style={{
              cursor:
                localStorage.getItem("language_type") === "en_US"
                  ? "auto"
                  : "pointer",
            }}
          >
            EN
          </span>
        </Col>
        <Col className="version-separator other-item">
          <span className="version-text version-line">—</span>
        </Col>
        <Col
          className={[
            "version-item",
            localStorage.getItem("language_type") === "zh_CN"
              ? "current-item"
              : "other-item",
          ]}
        >
          <span
            className="version-text"
            onClick={() => {
              toOther("zh_CN");
            }}
            style={{
              cursor:
                localStorage.getItem("language_type") === "zh_CN"
                  ? "auto"
                  : "pointer",
            }}
          >
            中文
          </span>
        </Col>
      </Row>
    </div>
  );
};

function Index(props) {
  const [collapsed, setCollapsed] = useState(false); //侧边栏菜单切换显隐
  const [exitVisible, setExitVisible] = useState(false);
  const [delVisible, setDelVisible] = useState(false);
  const [codeDisabled, setCodeDisabled] = useState(false); //
  const [codeText, setCodeText] = useState();
  const [code, setCode] = useState("");
  const [selectKeys, setSelectKeys] = useState([]);
  const user = JSON.parse(localStorage["userInfo-dots"] || "{}");
  const supplierbase = JSON.parse(localStorage.supplierbase || "{}");
  const inside = supplierbase.isOverseas == 1; // 是否海外(1:否 2：是)
  const [isMaximized, setIsMaximized] = useState(false);

  function checkMaximized() {
    setIsMaximized(isBrowserMaximized());
  }
  useEffect(() => {
    checkMaximized();
    window.addEventListener("resize", checkMaximized);
    return () => {
      window.removeEventListener("resize", checkMaximized);
    };
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    intl
      .init({
        currentLocale: localStorage.getItem("language_type") || "zh_CN",
        locales,
      })
      .then(() => {});
    setCodeText(
      intl.get("Send_verification_code_6f05c067-9da1-2c7b-8e3c-1f014c14565e")
    );
    let routeList = [];
    adminRoutes.map((route) => {
      if (route.children) {
        routeList = routeList.concat(route.children);
      }
      routeList.push(route);
    });
    const route = routeList.find(
      (item) => props.location.pathname.indexOf(item.path) !== -1
    );
    let newTitle =
      locales[
        localStorage.getItem("language_type")
          ? localStorage.getItem("language_type")
          : "zh_CN"
      ][route.title];
    setSelectKeys(newTitle ? [newTitle] : []);
    if (!user.permissionCodes && route.path !== "/login") {
      window.location.href = `/login`;
      return;
    }
    //无权限或无此路由
    if (
      route &&
      user?.permissionCodes &&
      user.permissionCodes.indexOf(route.key) === -1 &&
      route.path !== "/404" &&
      route.path !== "/login"
    ) {
      window.location.href = `/404`;
      return;
    }
    isDetailType() ? setDetailType(1) : setDetailType("");
  }, [props]);

  // 退出
  const logout = () => {
    loginOutApi1().then((res) => {
      if (res.code === 0) {
        window.location.href = `/login`;
        clearAccountInfo();
        // setExitVisible(false);
      } else {
        message.info(res.message);
      }
    });
  };
  //删除账户
  const delAccount = () => {
    if (!code) {
      message.warn(
        intl.get(
          "Please_enter_the_verification_code_fe7d2bae-6b48-23f9-aee7-9dde14986a39"
        )
      );
      return;
    }
    deleteAccount(code).then((result) => {
      if (result.code === 0) {
        clearAccountInfo();
        setDelVisible(false);
        setTimeout(() => {
          window.location.href = `/login`;
        }, 500);
      } else {
        message.error(result.message);
      }
    });
  };
  //header栏
  const menu = (
    <Menu
      onClick={(p) => {
        if (p.key === "logOut") {
          setExitVisible(true);
        } else if (p.key === "delAccount") {
          //弹窗提示
          setDelVisible(true);
        } else {
          message.info(p.key);
        }
      }}
    >
      <Menu.Item key="logOut">
        <LogoutOutlined />
        &nbsp;&nbsp;{intl.get("Logout_28d3d24d-88c7-2d94-aaff-e937e7b134a5")}
      </Menu.Item>
      {supplierbase.supplierStatus == 1 || supplierbase.supplierStatus == 5 ? (
        <Menu.Item key="delAccount">
          <DeleteOutlined />
          &nbsp;&nbsp;
          {intl.get("Delete_Account_9e3a49e5-9702-21cb-8268-c9299366f247")}
        </Menu.Item>
      ) : null}
    </Menu>
  );
  const onCancel = () => {
    setExitVisible(false);
  };
  const onExitOk = () => {
    logout();
  };
  const onDelOk = () => {
    delAccount();
  };
  const getVerifyCode = () => {
    sendVerifyCode1({
      type: supplierbase.isOverseas == 1 ? 1 : 2,
      account: supplierbase.isOverseas == 1 ? user.mobile : user.email,
      userType:
        localStorage.getItem("dots-userType") ||
        sessionStorage.getItem("dots-userType"),
    }).then((res) => {
      if (res.code == 0) {
        let count = 60;
        setCodeDisabled(true);
        const timer = setInterval(() => {
          if (count == 1) {
            count = 60;
            timer && clearInterval(timer);
            setCodeText(
              intl.get(
                "Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68"
              )
            );
            setCodeDisabled(false);
            return;
          }
          --count;
          setCodeText(
            `${count}${intl.get(
              "Resend_in_54e59247-0c76-20d5-8caa-c059d4c3bca1"
            )}`
          );
        }, 1000);
        message.success(
          intl.get(
            "The_verification_code_has_been_sent_6b1d0fcb-fa9c-24c6-9046-c340b507cdfe"
          )
        );
      } else {
        message.error(res.message);
      }
    });
  };
  const createMenu = (menu = []) => {
    let newMenu = menu.map((item) => {
      item.newTitle =
        locales[
          localStorage.getItem("language_type")
            ? localStorage.getItem("language_type")
            : "zh_CN"
        ][item.title];
      return item;
    });

    return newMenu.map((item) => {
      if (
        item.children &&
        item.children.filter(
          (ite) =>
            ite.showInMenu && user?.permissionCodes?.indexOf(ite.key) > -1
        ).length > 0
      ) {
        return (
          <SubMenu key={item.newTitle} title={item.newTitle} icon={item?.icon}>
            {createMenu(item.children)}
          </SubMenu>
        );
      } else {
        if (
          item.showInMenu &&
          user?.permissionCodes?.indexOf(item.key) !== -1
        ) {
          return (
            <Menu.Item
              key={item.newTitle}
              title={item.newTitle}
              icon={item?.icon}
            >
              <Link to={item.path}>{item.newTitle}</Link>
            </Menu.Item>
          );
        } else {
          return null;
        }
      }
    });
  };

  const getRoutesFromLocation = (location) => {
    let routes = [];
    const breadList = [];
    adminRoutes.map((route) => {
      routes.push(route);
      if (route.children) {
        routes = routes.concat(route.children);
      }
    });
    const sortList = routes.sort((a, b) => a.index - b.index);
    sortList.map((route) => {
      const path = (route.path || "").split(":")[0];
      if (location.pathname.indexOf(path) !== -1) {
        breadList.push(route);
      }
    });
    return breadList;
  };

  //面包屑跳转
  const toRedirct = (location, route) => {
    const pathParams = (route.path || "").split(":");
    let pathname = pathParams[0];
    pathParams.map((p, i) => {
      if (i > 0) {
        pathname += location.state[p];
      }
    });
    props.history.push({ pathname: pathname }, location.state);
  };

  const renderBreadCrumb = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation();
    const routes = getRoutesFromLocation(location);
    return (
      <Breadcrumb className="breadWrap breadNewWrap">
        {routes.map((route, index) => {
          if (index === routes.length - 1) {
            //详情页面展示名称
            if (
              route.path.indexOf("detail") !== -1 &&
              location.state &&
              location.state.name
            ) {
              return (
                <Breadcrumb.Item key={route.path}>
                  {location.state.name}
                </Breadcrumb.Item>
              );
            }
            if (route.path.indexOf("admin/train/trainCenter/detail") !== -1) {
              const arr = location.pathname.split("/");
              return (
                <Breadcrumb.Item key={route.path}>
                  {arr[arr.length - 1]}
                </Breadcrumb.Item>
              );
            }
            if (route.path.indexOf("admin/train/examCenter/detail") !== -1) {
              const arr = location.pathname.split("/");
              return (
                <Breadcrumb.Item key={route.path}>
                  {arr[arr.length - 1]}
                </Breadcrumb.Item>
              );
            }
            return (
              <Breadcrumb.Item key={route.path}>
                {intl.get(route.title)}
              </Breadcrumb.Item>
            );
          } else {
            //实训考试一级导航无点击事件
            if (route.children) {
              return (
                <Breadcrumb.Item key={route.path}>
                  {intl.get(route.title)}
                </Breadcrumb.Item>
              );
            }
            return (
              <Breadcrumb.Item key={route.path}>
                <span
                  className="clickStyle"
                  onClick={() => toRedirct(location, route)}
                >
                  {intl.get(route.title)}
                </span>
              </Breadcrumb.Item>
            );
          }
        })}
      </Breadcrumb>
    );
  };

  const [stateOpenKeys, setStateOpenKeys] = useState([]);
  const onOpenChange = (openKeys) => {
    setStateOpenKeys(
      openKeys && openKeys.length > 0
        ? openKeys.slice(openKeys.length - 1, openKeys.length)
        : []
    );
  };

  return (
    <div>
      <Layout>
        <Header
          className="site-layout-background site-layout-background1 header"
          style={{
            position: "fixed",
            zIndex: 1,
            width: "100%",
          }}
        >
          <div>
            <div className="logo">
              <img src={logo} width="100%" />
            </div>
          </div>

          {renderBreadCrumb()}

          <div>
            <>
              {VersionCompare()}
              {LanguageCompare()}
              <span
                style={{
                  display: "inline-block",
                  width: "1px",
                  height: "24px",
                  backgroundColor: "rgba(0,0,0,0.5)", // 浅灰色
                  margin: "0 24px",
                  verticalAlign: "middle",
                }}
              ></span>
            </>
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              className="inline-block pointer mr15"
            >
              <span>
                <div
                  className="touxiang"
                  // style={{ backgroundColor: getBgColor() }}
                >
                  {user?.name?.substr(0, 1)}
                </div>
                &nbsp;
                {user?.name} <DownOutlined />
              </span>
            </Dropdown>
          </div>
        </Header>
        <Layout hasSider style={{ minHeight: "calc(100vh - 64px)" }}>
          <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            width={220}
            style={{
              overflow: "auto",
              height: "100vh",
              position: "fixed",
              left: 0,
              top: 63,
              bottom: 0,
            }}
          >
            <Menu
              theme="light"
              defaultSelectedKeys={selectKeys}
              selectedKeys={selectKeys}
              mode="inline"
              className="frameMenu"
              openKeys={stateOpenKeys}
              onOpenChange={onOpenChange}
            >
              {createMenu(adminRoutes)}
            </Menu>
            {isMaximized && (
              <div
                style={{
                  position: "absolute",
                  bottom: "86px",
                  display: collapsed ? "none" : "block",
                  width: "100%",
                }}
              >
                <QuickActions />
              </div>
            )}
          </Sider>
          <Layout
            className="site-layout"
            style={{
              marginLeft: collapsed ? 80 : 220,
              marginTop: 64,
              backgroundColor: "#fff",
            }}
          >
            <Content>
              <div>{props.children}</div>
            </Content>
          </Layout>
        </Layout>
      </Layout>
      <Modal
        visible={exitVisible}
        title={intl.get("Logout_28d3d24d-88c7-2d94-aaff-e937e7b134a5")}
        onCancel={onCancel}
        footer={null}
        bodyStyle={{
          padding: 20,
        }}
      >
        <div>
          {intl.get("Make_sure_all_info_09e3a01e-e5be-21dc-97f4-5a9780a14ea5")}
        </div>
        <Row style={{ justifyContent: "center", marginTop: 20 }}>
          <Button type="primary" onClick={onExitOk}>
            {intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
          </Button>
          <Button style={{ marginLeft: 20 }} onClick={onCancel}>
            {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
          </Button>
        </Row>
      </Modal>

      {/* 删除账户 */}
      <Modal
        visible={delVisible}
        title={intl.get("Delete_Account_9e3a49e5-9702-21cb-8268-c9299366f247")}
        onCancel={() => {
          setDelVisible(false);
        }}
        footer={null}
        bodyStyle={{
          padding: 20,
        }}
      >
        <Row>
          <Col span={5}>
            {intl.get("Login_114f0f00-f1e3-28f0-8222-cb57b5cd8660")}：
          </Col>
          <Col>{supplierbase.isOverseas == 1 ? user.mobile : user.email}</Col>
        </Row>
        <Row style={{ marginTop: 20, alignItems: "center" }}>
          <Col span={5}>
            {intl.get("Verification_code_87ffdee6-31f4-272f-8285-202789b378d0")}
            ：
          </Col>
          <Col>
            <Row>
              <Col>
                <Input
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder={intl.get(
                    "Please_enter_the_verification_code_fe7d2bae-6b48-23f9-aee7-9dde14986a39"
                  )}
                ></Input>
              </Col>
              <Col>
                <Button
                  type="primary"
                  disabled={codeDisabled}
                  onClick={getVerifyCode}
                >
                  {codeText}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", marginTop: 20 }}>
          <Button
            type="primary"
            onClick={() => {
              setDelVisible(false);
            }}
          >
            {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
          </Button>
          <Button
            style={{ marginLeft: 20, borderColor: "red", color: "red" }}
            onClick={onDelOk}
          >
            {intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
          </Button>
        </Row>
        <Row style={{ justifyContent: "center", marginTop: 10, color: "red" }}>
          {intl.get("Account_ff05d5e9-569e-21b7-8a19-193846cdd936")}
        </Row>
      </Modal>
    </div>
  );
}
export default withRouter(Index);
